var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPhoneDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_82_1",
    "data-name": "Component 82 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.625,
    height: 41,
    viewBox: "0 0 25.625 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9079",
    "data-name": "Path 9079",
    d: "M15.375,33.313a2.563,2.563,0,1,1-2.563-2.562A2.56,2.56,0,0,1,15.375,33.313ZM25.625,3.844V37.156A3.845,3.845,0,0,1,21.781,41H3.844A3.845,3.845,0,0,1,0,37.156V3.844A3.845,3.845,0,0,1,3.844,0H21.781A3.845,3.845,0,0,1,25.625,3.844Zm-2.562,0a1.285,1.285,0,0,0-1.281-1.281H3.844A1.285,1.285,0,0,0,2.563,3.844V37.156a1.285,1.285,0,0,0,1.281,1.281H21.781a1.285,1.285,0,0,0,1.281-1.281Z",
    fill: "#0033A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhoneDark);
export default __webpack_public_path__ + "static/media/ico-phone-dark.354585edfb513f3fcfcf59349dec5bf4.svg";
export { ForwardRef as ReactComponent };